export default {
    baseStyle: {
        group: {
            mb: '10px'
        },
        container: {
            borderRadius: '10px',
            padding: '20px',
            border: '2px solid transparent',
            bg: 'neutral.50',
            backgroundClip: 'padding-box',
            position: 'relative',
            overflow: 'hidden',
            _before: {
                content: '""',
                position: 'absolute',
                inset: 0,
                padding: '2px',
                borderRadius: '10px',
                background: 'linear-gradient(90deg, #EDDEFF, #FFE9CB, #F1E02B)',
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                pointerEvents: 'none'
            }
        },
        header: {
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '15px',
            cursor: 'pointer'
        },
        headerContent: {
            flex: '1'
        },
        title: {
            fontSize: '20px',
            lineHeight: 'normal',
            color: 'black.100'
        },
        titleLabel: {
            fontFamily: 'caslon',
            fontWeight: '500'
        },
        titlePromoName: {
            fontFamily: 'cormorant',
            fontWeight: '400'
        },
        subtitle: {
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: '300',
            color: 'gray.800',
            lineHeight: '22px',
            letterSpacing: '0.065px'
        },
        toggleIcon: {
            width: '15px',
            height: '15px',
            transition: 'transform 0.25s ease'
        },
        productsWrapper: {
            pt: '15px',
            pb: '10px',
            overflow: 'hidden',
            minWidth: 0,
            sx: {
                '.swiper': {paddingRight: 0, overflow: 'hidden', width: '100%'},
                '.swiper-button-prev, .swiper-button-next': {
                    '--swiper-navigation-size': '35px',
                    display: {base: 'none', md: 'flex'},
                    top: '120px',
                    borderRadius: '5px',
                    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.20)',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    '&.swiper-button-disabled': {display: 'none'}
                },
                '.swiper-button-prev': {left: '5px', transform: 'rotate(180deg)'},
                '.swiper-button-next': {right: '5px'},
                '&:hover .swiper-button-prev, &:hover .swiper-button-next': {
                    opacity: 1
                },
                '.product-name': {
                    fontSize: '15px',
                    fontWeight: '400',
                    minHeight: 'unset'
                },
                '.display-price-wrapper, .display-price-wrapper *': {
                    fontSize: '13px !important',
                    fontWeight: '300 !important'
                },
                '.info-wrapper': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '.product-title': {order: 1},
                '.tile-price-box': {order: 2, marginBottom: {base: 0, lg: '10px'}},
                '.tile-content > .quick-add-parent.quick-add-parent': {
                    display: 'block !important',
                    gridArea: '3 / 1',
                    height: 'auto',
                    marginTop: 0,
                    marginInline: '10px'
                },
                '.tile-content > .quick-add-parent .quick-add-wrapper.quick-add-wrapper': {
                    position: 'unset',
                    opacity: '1 !important',
                    pointerEvents: 'auto',
                    display: 'block'
                },
                '.quick-add-button': {
                    fontSize: '13px',
                    fontWeight: '300',
                    padding: '2px 15px',
                    lineHeight: '20px',
                    width: '100%'
                },
                '.info-wrapper > .product-group-box': {
                    order: 4,
                    marginTop: {base: '5px', lg: '-10px'}
                },
                '.product-group-swatches-wrapper': {
                    justifyContent: 'center'
                },
                '.product-group-swatches-wrapper > .swatch-box': {
                    display: 'none !important'
                },
                '.swatch-more-text': {
                    fontSize: '13px',
                    fontWeight: '300',
                    color: '#746D63',
                    textDecoration: 'underline'
                }
            }
        },
        skeleton: {
            gap: '8px',
            overflow: 'hidden'
        },
        skeletonItem: {
            flex: '1',
            minWidth: 0,
            height: '280px',
            bg: 'gray.50',
            borderRadius: '3px'
        }
    },
    parts: [
        'group',
        'container',
        'header',
        'headerContent',
        'title',
        'titleLabel',
        'titlePromoName',
        'subtitle',
        'toggleIcon',
        'productsWrapper',
        'skeleton',
        'skeletonItem'
    ]
}
